import React from 'react';
import { Link } from 'react-router';
import './Testimonials.css';
import { FaStar } from 'react-icons/fa';
import testimonial1 from '../images/testimonials/testimonial1.jpg';
import testimonial2 from '../images/testimonials/testimonial2.jpg';
import testimonial3 from '../images/testimonials/testimonial3.jpg';
import testimonial4 from '../images/testimonials/testimonial4.jpg';
import testimonial5 from '../images/testimonials/testimonial5.jpg';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Njoroge',
      location: 'Nairobi',
      image: testimonial1,
      text: 'Investing with Faidika Real Estate was the best decision I made. The team was professional, transparent, and helped me secure a beautiful 1/4 acre plot in Springview Gardens. Highly recommended!',
      rating: 5
    },
    {
      id: 2,
      name: 'James Kipchoge',
      location: 'Kisumu',
      image: testimonial2,
      text: 'I was skeptical about land investments, but Faidika\'s team made the entire process smooth and hassle-free. My investment in Furaha City has already appreciated significantly. Thank you!',
      rating: 5
    },
    {
      id: 3,
      name: 'Mary Wambui',
      location: 'Mombasa',
      image: testimonial3,
      text: 'The professionalism and dedication of the Faidika team is unmatched. They walked me through every step, and I now own a beautiful acre plot. It\'s been a game-changer for my family.',
      rating: 5
    },
  ];

  return (
    <div className="testimonials-page">
      <div className="testimonials-header">
        <h1>Client Testimonials</h1>
        <p>Hear from our satisfied customers who have transformed their futures with Faidika Real Estate</p>
      </div>

      <div className="testimonials-container">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-image-wrapper">
              <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
            </div>
            
            <div className="testimonial-content">
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="star" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.text}"</p>

              <div className="testimonial-author">
                <h3>{testimonial.name}</h3>
                <p className="author-location">{testimonial.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="testimonials-cta">
        <h2>Ready to Start Your Investment Journey?</h2>
        <p>Join hundreds of satisfied clients who have invested with Faidika Real Estate</p>
        <Link to="/Properties" className="cta-button">Get Started Today</Link>
      </div>
    </div>
  );
};

export default Testimonials;
